/* eslint-disable */
import React, { useState } from "react";
import FilterDropdown from "./FilterDropdown";

const ChallengeLeaderboardFilter = ({
  isFollowingChecked = false,
  handleFollowingChange,
  selectedStatus = "all",
  handleStatusChange,
}) => {

  return (
    <FilterDropdown
      isFollowingChecked={isFollowingChecked}
      handleFollowingChange={handleFollowingChange}
      selectedStatus={selectedStatus}
      handleStatusChange={handleStatusChange}
    />
  );
};

export default ChallengeLeaderboardFilter;
